import { render, staticRenderFns } from "./PneuTable.vue?vue&type=template&id=652214fd&"
import script from "./PneuTable.vue?vue&type=script&lang=ts&"
export * from "./PneuTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports